import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { pdsCustomElement as customElement } from '../../decorators/pds-custom-element';
import { PdsElement } from '../PdsElement';
import styles from './logout-page.scss?inline';
import '../layout-container/layout-container';
import '../heading/heading';
import '../text-passage/text-passage';
import '../link/link';

/**
 * @summary This component renders a logout page
 */
@customElement('pds-logout-page', {
  category: 'component',
  type: 'component',
  state: 'stable',
  styles,
})
export class PdsLogoutPage extends PdsElement {
  connectedCallback() {
    super.connectedCallback();
    this.initLocalization();
  }

  /**
   * Style variant
   * - **primary** renders the logout-page used for default logout
   * - **expired** renders the logout-page used for session expired logout
   */
  @property({ type: String })
  variant: 'default' | 'expired' = 'default';

  /**
   * Login link
   * - Login link for login button
   */
  @property({ type: String })
  loginLink = 'https://login.principal.com/login';

  /**
   * variant for layout container
   * - **narrow** renders the layout-container narrower than the default
   */
  @property({ type: String })
  layoutContainerVariant?: 'default' | 'narrow' = 'default';

  /**
   * @internal
   */
  getLogoutHeadline() {
    if (this.variant === 'expired') {
      return this.translateText('session-expired');
    }

    return this.translateText('logged-out');
  }

  /**
   * @internal
   */
  getLogoutText() {
    if (this.variant === 'expired') {
      return this.translateText('we-logged-you-out');
    }

    return this.translateText('not-what-you-wanted');
  }

  /**
   * @internal
   */
  get classNames() {
    return {
      [this.variant]: !!this.variant,
    };
  }

  render() {
    return html`<div class=${this.getClass()}>
      <pds-layout-container
        variant="${this.layoutContainerVariant}"
        removePadding="all"
        class="${this.classEl('layout-container')}"
      >
        <div class="${this.classEl('container')}">
          <div class="${this.classEl('content-container')}">
            <div>
              <pds-text-passage>
                <pds-heading
                  headingTag="h1"
                  variant="display-default"
                  class="${this.classEl('heading')}"
                >
                  ${this.getLogoutHeadline()}
                </pds-heading>
                <p class="${this.classEl('text')}">${this.getLogoutText()}</p>
              </pds-text-passage>
            </div>
            <div>
              <pds-link href=${this.loginLink} button="default"
                ><span>${this.translateText('log-back-in')}</span></pds-link
              >
            </div>
          </div>
          <div class="${this.classEl('svg-container')}">
            <div class="${this.classEl('svg')}"></div>
          </div>
        </div>
      </pds-layout-container>
    </div>`;
  }
}
